import React, { useState, useEffect, Fragment } from 'react';
import { useDropzone } from 'react-dropzone';
import {
    Row,
    Button,
    Modal, ModalBody,
    ModalHeader,
    ModalFooter,
    CustomInput
} from 'reactstrap';
import classnames from 'classnames';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { postAPI_User_Integration_Images } from '../../../../../constants/APIs';

export default function UploadImage({ botsetting, propertyId, visible, toggle, GetUploadedImage }) {
    const fileObj = [];
    const [files, setFiles] = useState([]);
    const [errorModal, showErrorModal] = useState(false);
    const [ApiState, setApiState] = useState('default');
    const [isAgree, setAgree] = useState(false);
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: (acceptedFiles) => {
            acceptedFiles.map((file) =>
                fileObj.push({
                    img: Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    }),
                })
            );

            setFiles([...files, ...fileObj]);
        },
    });
    useEffect(
        () => () => {
            files.forEach((file) => URL.revokeObjectURL(file.preview));
        },
        [files]
    );
    const handleSubmit = () => {
        if (isAgree) {
            const data = new FormData();
            files.forEach((file) => {
                data.append('files', file.img);
            });
            data.append('propertyId', propertyId);
            data.append('groupId', getGroupID());
            data.append('creator', 'dashboard');
            setApiState('processing');
            AxiosAPI({
                method: 'post',
                url: `${postAPI_User_Integration_Images}`,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(
                (res) => {
                    GetUploadedImage({ id: res.data.id, imageLink: res.data.src });
                    setApiState('success');
                    toggle();
                },
                (error) => {
                    setApiState('fail');
                    console.log('eee.data', error.data);
                }
            );
        } else {
            showErrorModal(true);
        }
    };
    const handleRemoveFields = (index) => {
        const values = [...files];
        values.splice(index, 1);
        setFiles(values);
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    Please Upload your screenshot here
                </ModalHeader>
                <ModalBody>
                    <Row className="mb-4">
                        <section className="container" style={{ flexWrap: "wrap", justifyContent: "space-evenly" }}>
                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input {...getInputProps()} />
                                <div className="dz-default dz-message">
                                    <span>
                                        Drop files here to upload, or click to select files
                                    </span>
                                    <p className="font-weight-medium mb-0 ">
                                        <i className="demo-icon simple-icon-cursor-move"></i>
                                    </p>
                                </div>
                            </div>
                            <div
                                className="filepicker dropzone-gallery dz-clickable dz-started"
                                style={{ minHeight: '160px', border: '0px' }}
                            >
                                {files.map((file, index) => (
                                    <div className="dz-preview dz-file-preview mb-3" key={index} style={{ height: "100px" }}>
                                        <div className="row">
                                            <div className="p-0 w-30 position-relative">
                                                <div className="preview-container">
                                                    <img
                                                        data-dz-thumbnail
                                                        className="img-thumbnail border-0"
                                                        src={file.img.preview}
                                                        style={{ display: 'block' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                                                <div>
                                                    {' '}
                                                    <span data-dz-name>{file.img.name}</span>{' '}
                                                </div>
                                                <div
                                                    className="text-primary text-extra-small"
                                                    data-dz-size
                                                >
                                                    {file.img.size}
                                                </div>
                                            </div>

                                        </div>

                                        <a
                                            href="#/"
                                            className="remove"
                                            data-dz-remove
                                            onClick={() => handleRemoveFields(index)}
                                        >
                                            {' '}
                                            <i className="glyph-icon simple-icon-trash" />{' '}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </Row>
                    <div className="row my-1 ml-0  font-weight-bold">
                        <CustomInput
                            type="checkbox"
                            id="agree"
                            value={isAgree}
                            checked={isAgree}
                            onChange={(e) => {
                                setAgree(!isAgree);
                            }}
                        >
                            <span className="mt-1" style={{ verticalAlign: 'middle' }}>
                                I have copyright or permissions to use this image
                            </span>
                        </CustomInput>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={handleSubmit}
                        className={`btn-multiple-state ${classnames({
                            'show-spinner': ApiState === 'processing',
                            'show-success': ApiState === 'success',
                            'show-fail': ApiState === 'fail',
                        })}`}
                    >
                        <span className="spinner d-inline-block">
                            <span className="bounce1" />
                            <span className="bounce2" />
                            <span className="bounce3" />
                        </span>
                        <span className="icon success">
                            <i className="simple-icon-check" />
                        </span>
                        <span className="icon fail">
                            <i className="simple-icon-exclamation" />
                        </span>
                        <span className="label">Save</span>
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={errorModal} toggle={() => showErrorModal(!errorModal)}>
                <ModalHeader toggle={() => showErrorModal(!errorModal)}>
                    Upload Image
                </ModalHeader>
                <ModalBody>
                    <div className="m-2">
                        <h5>Please check the copyright or permissions check box</h5>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => showErrorModal(!errorModal)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}